import React from 'react';
// import Spinner from 'resources/images/spinner.gif';
// import Spinner from 'assets/images/spinner.gif';
import Spinner from './spinner.gif';
import CircularProgress from '@mui/material/CircularProgress';

const FullPageLoader = () => {
  return (
    <div className="fp-container">
      <img src={Spinner} className="fp-loader" alt="loading" />
      {/* <CircularProgress /> */}
    </div>
  );
};

export default FullPageLoader;
